import { useSelector } from "react-redux";
import { RootState } from "../ducks";
import { isItemAvailableAtLocation } from "../helpers";
import { CatalogItem, Location } from "../queries/auto-generated/schemas";

export const useItemAvailability = () => {
  const {
    data: { locations },
  } = useSelector((state: RootState) => state.location);

  const isAvailableAtLocation = (
    catalogItem: CatalogItem,
    locationJOOId?: Location["id"]
  ) => {
    if (!locationJOOId) {
      return false;
    }
    const location = locations[locationJOOId];
    if (!location) {
      return false;
    }

    const locationSquareId = location.square_id;
    return isItemAvailableAtLocation(catalogItem, locationSquareId);
  };

  return { isAvailableAtLocation };
};
